import React from 'react';
import { AwardIcon, CheckIcon } from 'lucide-react';
export function TrainingSection() {
  return <section className="w-full py-16 md:py-20" style={{
    backgroundColor: '#f8f6f0'
  }} aria-label="Training Offered" data-id="element-1986">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-1987">
        <div className="text-center mb-12" data-id="element-1988">
          <p className="text-xs font-bold uppercase tracking-widest mb-2" style={{
          color: '#c8a84b',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1989">
            Certified Instruction
          </p>
          <h2 className="text-3xl md:text-4xl font-bold uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-1990">
            Training Offered
          </h2>
          <div className="section-divider-center" data-id="element-1991" />
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold" style={{
          backgroundColor: '#f0f7f3',
          color: '#2d5a3d',
          border: '1px solid #d6ebe0',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1992">
            <AwardIcon size={15} data-id="element-1993" />
            by NRA Certified Instructors
          </div>
        </div>

        <div className="rounded-2xl overflow-hidden" style={{
        border: '1px solid #ede9e0',
        boxShadow: '0 4px 16px rgba(0,0,0,0.06)'
      }} data-id="element-1994">
          <div className="px-6 py-4" style={{
          backgroundColor: '#1e3d2f'
        }} data-id="element-1995">
            <p className="text-sm font-semibold uppercase tracking-wider" style={{
            color: '#c8a84b',
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-1996">
              Available Courses
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 divide-y md:divide-y-0 md:divide-x" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1997">
            <div className="p-6 md:p-8 bg-white" data-id="element-1998">
              <ul className="space-y-3" data-id="element-1999">
                {['First Time Pistol Owner Orientation', 'NRA First Basic Pistol', 'NRA First Steps Rifle', 'NRA First Steps Shotgun', 'NRA Instructor Training Courses'].map(course => <li key={course} className="flex items-start gap-3" data-id="element-2000">
                    <div className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                  backgroundColor: '#f0f7f3',
                  border: '1px solid #d6ebe0'
                }} data-id="element-2001">
                      <CheckIcon size={11} style={{
                    color: '#2d5a3d'
                  }} data-id="element-2002" />
                    </div>
                    <span className="text-sm" style={{
                  color: '#3a3a3a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2003">
                      {course}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="p-6 md:p-8 bg-white" data-id="element-2004">
              <ul className="space-y-3" data-id="element-2005">
                {['NRA Personal Protection In The Home (CPL/CCW Requirement)', 'NRA Personal Protection Outside The Home Levels 1 & 2', 'NRA RSO (Range Safety Officer)', 'Michigan Concealed Pistol License (CPL)', 'Michigan CPL Renewal Class'].map(course => <li key={course} className="flex items-start gap-3" data-id="element-2006">
                    <div className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                  backgroundColor: '#f0f7f3',
                  border: '1px solid #d6ebe0'
                }} data-id="element-2007">
                      <CheckIcon size={11} style={{
                    color: '#2d5a3d'
                  }} data-id="element-2008" />
                    </div>
                    <span className="text-sm" style={{
                  color: '#3a3a3a',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-2009">
                      {course}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="px-6 py-4 flex flex-wrap gap-3" style={{
          backgroundColor: '#f8f6f0',
          borderTop: '1px solid #ede9e0'
        }} data-id="element-2010">
            <a href="/Calendar.html" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
            backgroundColor: '#1e3d2f',
            color: '#ffffff',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2011">
              View Class Schedule
            </a>
            <a href="/NRAFirstStepsPistol.html" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg font-medium text-sm border transition-all" style={{
            borderColor: '#2d5a3d',
            color: '#2d5a3d',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2012">
              NRA First Steps Pistol
            </a>
            <a href="/NRAPersonalProtectionInTheHome.html" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg font-medium text-sm border transition-all" style={{
            borderColor: '#2d5a3d',
            color: '#2d5a3d',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2013">
              Michigan CPL Course
            </a>
          </div>
        </div>
      </div>
    </section>;
}